import React from "react"

export default function({title, children}) {
  return (
    <>
      <h3 className="tit_cont">{title}</h3>
      {children}
    </>
  )
}
